export function removeLeadingZeros(value: string): string {
  // Only process string values that look like numbers
  if (value !== '' && !Number.isNaN(Number(value))) {
    // Convert to number and back to string to remove leading zeros
    // This handles cases like "090" -> "90" but keeps "0.5" as "0.5"
    const numValue = parseFloat(value);

    return numValue.toString();
  }

  return value;
}

